import { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'

const ThemedToastContainer = () => {
  const [mode, setMode] = useState('dark')

  useEffect(() => {
    const root = document.documentElement
    const read = () =>
      root.getAttribute('data-theme') === 'light' ? 'light' : 'dark'

    setMode(read())

    const obs = new MutationObserver(() => setMode(read()))
    obs.observe(root, { attributes: true, attributeFilter: ['data-theme'] })
    return () => obs.disconnect()
  }, [])

  return <ToastContainer theme={mode} />
}

export default ThemedToastContainer
